import * as Yup from 'yup';

export const schema = [
  {
    name: 'name',
    initialValue: '',
    validation: Yup.string().required('Company name is required.'),
    input: {
      placeholder: 'Company Name',
      className: 'companyName',
      type: 'input',
    },
  },
  {
    name: 'code',
    initialValue: '',
    validation: Yup.string().required('Registry code is required.'),
    input: {
      placeholder: 'Registry Code',
      className: 'registryCode',
      type: 'input',
    },
  },
  {
    name: 'VAT',
    initialValue: '',
    validation: Yup.string().required('VAT is required.'),
    input: {
      placeholder: 'VAT no',
      className: 'vat',
      type: 'input',
    },
  },
  {
    name: 'bankName',
    initialValue: '',
    validation: Yup.string().required('Bank name is required.'),
    input: {
      placeholder: 'Bank',
      className: 'bank',
      type: 'input',
    },
  },
  {
    name: 'bankIBAN',
    initialValue: '',
    validation: Yup.string().required('Bank IBAN is required.'),
    input: {
      placeholder: 'Bank account / IBAN',
      className: 'iban',
      type: 'input',
    },
  },
  {
    name: 'bankSWIFT',
    initialValue: '',
    validation: Yup.string().required('Bank SWIFT is required.'),
    input: {
      placeholder: 'SWIFT / BIC',
      className: 'swift-bic',
      type: 'input',
    },
  },
  {
    name: 'email',
    initialValue: '',
    validation: Yup.string().required('Email is required.'),
    input: {
      placeholder: 'Company Email',
      className: 'companyEmail',
      type: 'input',
    },
  },
  {
    name: 'address',
    initialValue: '',
    input: {
      placeholder: 'Current stored address',
      className: 'address-1',
      type: 'input',
    },
  },
  {
    name: 'address2',
    initialValue: '',
    validation: Yup.string().required('Address is required.'),
    input: {
      placeholder: 'New address',
      className: 'address-2',
      type: 'input',
    },
  },
  {
    name: 'city',
    initialValue: '',
    validation: Yup.string().required('City is required.'),
    input: {
      placeholder: 'City',
      className: 'city',
      type: 'input',
    },
  },
  {
    name: 'state',
    initialValue: '',
    validation: Yup.string().required('State is required.'),
    input: {
      placeholder: 'State',
      className: 'state',
      type: 'input',
    },
  },
  {
    name: 'postalCode',
    initialValue: '',
    validation: Yup.string().required('Zip code is required.'),
    input: {
      placeholder: 'ZIP',
      className: 'zip',
      type: 'input',
    },
  },
  {
    name: 'country',
    initialValue: '',
    validation: Yup.string().required('Country is required.'),
    input: {
      placeholder: 'Country',
      className: 'country',
      type: 'input',
    },
  },
];
